import classNames from 'classnames'
import { useState } from 'react'

import type { ReactElement } from 'react'

import GridView from './GridView'
import TableView from './TableView'

import SwitchButton from '~/components/Buttons/SwitchButton'
import ViewTitle from '~/components/ViewTitle'
import useDocumentTitle from '~/hooks/useDocumentTitle'

import './styles.scss'

const Templates = (): ReactElement => {
  /** Local state */

  const [view, setView] = useState<string>('list')

  const switchButtonClasses = classNames('templates-switch-button', { active: view === 'list' })

  /** Effects */

  useDocumentTitle('DS Templates')

  /** Handlers */

  const handleSwitchChange = (id: string) => setView(id)

  /** Render */

  return (
    <div className="templates-view">
      <ViewTitle className="layout-view-title top-zero">
        <div>Templates</div>
        <SwitchButton
          buttons={[
            { content: 'List', id: 'list', isActive: view === 'list' },
            { content: 'Grid', id: 'grid', isActive: view === 'grid' },
          ]}
          className={switchButtonClasses}
          onButtonSelectionChange={handleSwitchChange}
          size="small"
        />
      </ViewTitle>
      {view === 'list' ? <TableView /> : <GridView />}
    </div>
  )
}

export default Templates
